module.exports = __webpack_public_path__ + "static/media/fly0063.1941d047.webp";